module.exports = __webpack_public_path__ + "img/35.176e78a2.gif";